<!--
 * @Date: 2023-12-26 14:58:21
 * @Author: jm
 * @LastEditTime: 2024-05-13 14:50:50
 * @LastEditors: jm
 * @FilePath: \arcadearchipelago\src\components\HeaderSwiper.vue
 * @Description: 
-->
<template>
  <div class="swiper-container casual">
    <div class="swiper-wrapper">
      <div
        class="swiper-slide"
        v-for="(item, i) in dataList"
        v-if="dataList.length > 0"
        @click="clickImg(item)"
      >
        <div class="container-slide">
          <img :src="item.gameBigImage" class="swiper-pic" />
          <div class="bottom">
            <img :src="item.gamelogo" alt="" class="smallImg" />
            <div class="right">
              <p class="name">{{ item.gamename }}</p>
              <StarCount
                :imgUrl="star"
                :starwidth="0.37037"
                :starRight="0.23"
                :starLeft="-0.2"
              ></StarCount>
            </div>
            <div class="start">
              <p>PLAY</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import StarCount from "@/components/StarCount.vue";
import star from "@/assets/images/star.png";
export default {
  components: { StarCount },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      star,
      activeIndex: 0,
    };
  },
  mounted() {
    //监听屏幕宽度和高度变化
  },
  methods: {
    //页面变化执行
    //初始化轮播图
    init() {
      let _this = this;

      var swiper = new Swiper(".casual", {
        // direction: 'vertical', // 垂直切换选项
        loop: true, // 循环模式选项
        slidesPerView: 1.3,
        spaceBetween: 25,
      });
    },
    //点击轮播图
    clickImg(data) {
      this.$emit("onClick", data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.casual {
  width: 1000px;
  height: auto;
  margin: 60px auto;
}
.swiper-slide {
  // background-color: palevioletred;
  text-align: center;
  font-size: 18px;
  height: 653px !important;
  line-height: 360px !important;
  margin-top: 0px !important;
}
.container-slide {
  width: 767px;
  height: 603px;
  padding: 25px 0px;
  border-radius: 20px;
  background: #333333;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  .swiper-pic {
    width: 698px;
    height: 419px;
    border-radius: 40px;
    box-shadow: 0px 0px 10px 5px rgba(0, 0, 0, 0.3);
  }
  .bottom {
    width: 698px;
    padding: 26px 0px 50px;
    border-radius: 0px 0px 30px 30px;
    display: flex;
    align-items: center;
    color: #ffffff;
    .smallImg {
      width: 140px;
      height: 140px;
      border-radius: 100px;
    }
    .right {
      width: 55%;
      height: 140px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      margin-left: 25px;
      .name {
        width: 90%;
        height: 55px;
        line-height: 55px;
        margin-bottom: 30px;
        font-size: 40px;
        font-weight: bold;
        text-align: left;
        @include textoverflow(1);
      }
    }
    .start {
      width: 184px;
      height: 75px;
      border-radius: 40px;
      background: #ff3434;
      text-align: center;
      p {
        line-height: 75px;
        font-size: 35px;
        font-weight: 900;
      }
    }
  }
}
</style>
